import { Dialog } from "@progress/kendo-react-dialogs";

import { Grid, GridColumn } from "@progress/kendo-react-grid";

function DashBoardCardDetails({ onClose, selectedList, operation }) {

  return (
    <Dialog
      onClose={onClose}
      title={'Details'}
      className="small-dailog width_90 dialogMaxHeight" width={"50%"} 
    >
      <Grid
        data={operation===1?selectedList.sort((b, a) => a.totalAddition - b.totalAddition):selectedList.sort((a, b) => a.totalRemoval - b.totalRemoval)}
        checkboxElement
        className="grid-table filter-grid mt-10"
      >
       
        <GridColumn
          className="cursor-default"
          field="clinicName"
          title="Clinic"
          width="300px"
          max-width="30px"
          min-width="150px"
        />
        <GridColumn
          className="cursor-default"
          field="totalAddition"
          title={"Additions"  }
          width="150px"
          max-width="30px"
          min-width="150px"
        />
        
         <GridColumn
          className="cursor-default"
          field="totalRemoval"
          title={"Removal" }
          width="150px"
          max-width="30px"
          min-width="150px"
        />

         <GridColumn
          className="cursor-default"
          field="total"
          title={"Total" }
          width="150px"
          max-width="30px"
          min-width="150px"
        />
        </Grid>

    </Dialog>
  );
}
export default DashBoardCardDetails;
